import { getCols } from "../../common/getCols.ts";
import type { View } from "../../common/types.ts";
import { helpers } from "../util/helpers.ts";

// Escape controls so imported names cannot break spreadsheet row boundaries.
export const clipboardRow = (cells: unknown[]) => cells.map((cell) => String(cell ?? "").replace(/[\t\r\n]+/g, " ")).join("\t");

export const getStatVal = (ps: Record<string, any>, stat: string, totals = false): string => {
	let value = ps[stat];
	if (stat.endsWith("Max")) value = Array.isArray(value) ? value[0] : undefined;
	if (value === undefined || value === null) return "";
	if (__SPORT === "baseball" && ps.pos !== "C" && ["pb", "sbF", "csF", "csp"].includes(stat)) return "";
	return helpers.roundStat(value, stat, totals);
};

export const formatSuperCols = (superCols: { title?: unknown; colspan: number }[], extraColspan = 0) => clipboardRow(superCols.flatMap((col, i) => [col.title, ...Array(Math.max(0, col.colspan + (i === 0 ? extraColspan : 0) - 1)).fill("")]));

export const getMultiPlayerClipboardData = (sections: View<"playerStats">[]) => sections.map(({ players, stats, season, playoffs, statType, superCols }) => {
	const lines = [`${statType} — ${playoffs === "playoffs" ? "Playoffs" : "Regular Season"}`];
	if (superCols) lines.push(formatSuperCols(superCols, -1)); // Omit the rank column.
	lines.push(clipboardRow(getCols(["Name", "Pos", "Age", "Team", ...(season === "all" ? ["Season"] : []), ...stats.map((stat) => stat === "pos" ? "Pos" : `stat:${stat.replace(/Max$/, "")}`)]).map((col) => col.title)));
	for (const p of players) lines.push(clipboardRow([
		`${p.firstName} ${p.lastName}`, p.pos,
		season === "career" ? p.age : p.stats.season - p.born.year,
		season === "career" ? p.abbrev : p.stats.abbrev,
		...(season === "all" ? [p.stats.season] : []),
		...stats.map((stat) => getStatVal(p.stats, stat, statType === "totals")),
	]));
	return lines.join("\n");
}).join("\n\n");
